import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Reveal, Chapter } from "./Reveal";
import { INGREDIENTS } from "../data/content";

export default function Research() {
  return (
    <section id="research" data-testid="research-section" className="bg-white py-24 lg:py-32">
      <div className="mx-auto max-w-7xl px-5 lg:px-8">
        <Chapter num="01" label="The Science" />

        <div className="mb-16 max-w-3xl lg:mb-20">
          <Reveal>
            <h2 className="font-display text-4xl font-extrabold tracking-tight text-fv-navy sm:text-5xl lg:text-6xl">
              THE SCIENCE BEHIND
              <br />
              <span className="text-fv-blue">FELLESVIAR</span>
            </h2>
          </Reveal>
          <Reveal delay={0.15}>
            <p className="mt-6 max-w-xl text-base leading-relaxed text-fv-navy/60 md:text-lg">
              Powered by 4 clinically studied ingredients for comprehensive
              joint support.
            </p>
          </Reveal>
        </div>

        <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-4" data-testid="ingredient-cards">
          {INGREDIENTS.map((ing, i) => (
            <Reveal key={ing.slug} delay={i * 0.1}>
              <div
                data-testid={`ingredient-card-${ing.slug}`}
                className="group flex h-full flex-col rounded-3xl border border-blue-100 bg-white p-7 shadow-sm transition-all duration-500 hover:-translate-y-2 hover:border-fv-blue/40 hover:shadow-2xl hover:shadow-fv-blue/10"
              >
                <div className="relative mx-auto mb-7 h-32 w-32">
                  <div className="absolute -inset-2 rounded-full border border-dashed border-fv-blue/30 transition-transform duration-700 group-hover:rotate-45" />
                  <img
                    src={ing.image}
                    alt={ing.name}
                    loading="lazy"
                    className="h-32 w-32 rounded-full border-4 border-fv-ice object-cover transition-transform duration-500 group-hover:scale-105"
                  />
                  <span className="absolute -right-1 -top-1 flex h-8 w-8 items-center justify-center rounded-full bg-fv-blue font-display text-xs font-bold text-white shadow-lg shadow-fv-blue/40">
                    {ing.num}
                  </span>
                </div>

                <h3 className="font-display text-lg font-bold leading-snug text-fv-navy">
                  {ing.name}
                </h3>
                {ing.patentLogo && (
                  <div className="mt-3 inline-flex self-start items-center rounded-lg border border-blue-100 bg-white px-3 py-1.5 shadow-sm">
                    <img
                      src={ing.patentLogo}
                      alt={`${ing.name} patented brand logo`}
                      className="h-5 w-auto object-contain"
                      data-testid={`patent-logo-${ing.slug}`}
                    />
                  </div>
                )}
                <p className="mt-3 flex-1 text-sm leading-relaxed text-fv-navy/60">
                  {ing.short}
                </p>

                <Link
                  to={`/research/${ing.slug}`}
                  data-testid={`view-research-${ing.slug}`}
                  className="mt-6 inline-flex items-center justify-center gap-2 rounded-full border-2 border-fv-blue px-5 py-2.5 text-xs font-bold tracking-[0.12em] text-fv-blue transition-all duration-300 hover:bg-fv-blue hover:text-white hover:shadow-lg hover:shadow-fv-blue/30"
                >
                  VIEW RESEARCH
                  <ArrowRight className="h-3.5 w-3.5 transition-transform duration-300 group-hover:translate-x-0.5" />
                </Link>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
